import styled from 'styled-components'

export const BannerSection = styled.section`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  overflow: hidden;
  background: #000;
`

export const VideoWrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 647px;
  max-width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 482px;
  }
`

export const StyledVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  padding: 0 10px;
  object-fit: cover;
  object-position: center;
  z-index: 0;
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background: rgba(33, 16, 93, 0.5);
  z-index: 1;
`

export const Content = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  pointer-events: none;
  padding: 18px;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`

export const Title = styled.h1`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  color: #fff;
  text-align: center;
  margin: 0;
  pointer-events: auto;

  @media (max-width: 768px) {
    max-width: 350px;
    font-size: 24px;
    line-height: 32px;
    margin: 0;
    margin-top: 32px;
    font-style: bold;
    letter-spacing: 0%;
  }
`

export const Subtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 100%;
  color: #fff;
  text-align: center;
  margin-top: 25px;
  margin-bottom: 0;
  pointer-events: auto;

  @media (max-width: 768px) {
    max-width: 600px;
    font-size: 16px;
    line-height: 20px;
    margin-top: 32px;
    margin-bottom: 0;
    font-style: semi-bold;
    letter-spacing: 0%;
    vertical-align: middle;
  }
`

export const BannerButton = styled.button`
  height: 64px;
  margin-top: 25px;
  border: 2px solid #fff;
  border-radius: 11px;
  padding: 16px;
  background: transparent;
  color: #fff;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 2%;
  cursor: pointer;
  pointer-events: auto;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: var(--orange3, #f88621);
    border-color: var(--orange3, #f88621);
  }

  @media (max-width: 768px) {
    height: 42px;
    border-width: 1px;
    border-radius: 10px;
    padding: 8px;
    font-weight: 600;
    font-size: 13px;
    line-height: 22px;
    min-width: 120px;
    margin-top: 17px;
    gap: 10px;
    font-style: semi-bold;
    letter-spacing: 0%;
    text-align: center;
    width: auto;
  }
`

export const Note = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: #fff;
  text-align: center;
  margin-top: 25px;
  pointer-events: auto;

  @media (max-width: 768px) {
    font-size: 8px;
    margin-top: 8px;
    font-style: normal;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
  }
`
